































import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from '../components/Button.vue';
import Api from '../utils/Api';

@Component({
	components:{
		Button
	}
})
export default class Home extends Vue {

	public message:string = "";
	public loading:boolean = false;
	public success:boolean = false;
	public error:boolean = false;
	public maxChars:number = 250;

	public get total():number {
		return this.$store.state.total;
	}
	public get chars():number {
		return this.message.length;
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public onSubmit():void {
		if(this.message.length < 20) {
			this.$store.state.alert = "Un petit effort sur la longueur du message steup' ? 😜";
			return;
		}
		this.loading = true;
		this.success = false;
		this.error = false;
		Api.post("message", {message:this.message})
		.then(res=> {
			this.$store.dispatch("incrementCount");
			this.success = true;
			this.message = "";
			setTimeout(_=> {
				this.success = false;
			}, 5000);
		}).catch(error => {
			this.error = true;
			setTimeout(_=> {
				this.error = false;
			}, 10000);
			this.$store.state.alert = "Oops...<br />"+error.message;
		}).then(_=> {
			this.loading = false;
			window.scrollTo(0, document.body.scrollHeight);
		});
	}

}
